import {
  Box,
  Flex,
  LegacyText,
  PrimaryButton,
  RadioGroup,
  Stack,
} from "flicket-ui";
import { Select } from "~components";
import { useIsMobile } from "~hooks";
import {
  AlcoholFreeZoneTypes,
  CoverTypes,
  SortTypes,
} from "~components/reservation/constants";

type OptionsProps = {
  handleClose: () => void;
  setAmount: (amount: number) => void;
  amount: number;
  seatAmountOptions: any;
};

// eslint-disable-next-line react/prop-types
export const CoverType = ({ selectedType, changeCoverType }) => (
  <Stack flexDir="column" width="100%" mb={3}>
    <RadioGroup
      variant="plain"
      value={selectedType}
      onValueChange={changeCoverType}
      options={[
        {
          name: "No preference",
          value: CoverTypes.ALL,
        },
        {
          name: "Covered",
          value: CoverTypes.COVERED,
        },
        {
          name: "Uncovered",
          value: CoverTypes.UNCOVERED,
        },
      ]}
    />
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const AlcoholFreeZone = ({ alcoholFreeZone, changeAlcoholFreeZone }) => (
  <Stack flexDir="column" space={5} width="100%" mb={2}>
    <RadioGroup
      variant="plain"
      value={alcoholFreeZone}
      onValueChange={changeAlcoholFreeZone}
      options={[
        {
          name: "No preference",
          value: AlcoholFreeZoneTypes.NO_PREFERENCE,
        },
        {
          name: "Yes",
          value: AlcoholFreeZoneTypes.YES,
        },
        {
          name: "No",
          value: AlcoholFreeZoneTypes.NO,
        },
      ]}
    />
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const SortBy = ({ selectedSort, changeSort }) => {
  return (
    <Stack flexDir="column" space={5} width="100%" mb={2}>
      <RadioGroup
        variant="plain"
        value={selectedSort}
        onValueChange={changeSort}
        options={[
          {
            name: "Best available",
            value: SortTypes.BEST_AVAILABLE,
          },
          {
            name: "Price",
            value: SortTypes.PRICE,
          },
        ]}
      />
    </Stack>
  );
};

export const Options = ({
  handleClose,
  setAmount,
  amount,
  seatAmountOptions,
}: OptionsProps) => {
  const isMobile = useIsMobile();
  return (
    <Flex flexDir="column" width="100%" p={{ _: 2, md: 0 }}>
      <Box>
        <LegacyText fontWeight="extraBold" color="N800" fontSize={2} mb="6/4">
          I need tickets for
        </LegacyText>
        <Select
          value={seatAmountOptions.find((opt) => opt.value === amount)}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          onChange={(value) => setAmount(value)}
          options={seatAmountOptions}
          mb={5}
          selectProps={{
            // 300 is the default max menu height
            // This fixes a bug on android Chrome
            // where the dropdown does off the bottom viewport
            maxMenuHeight: isMobile ? 150 : 300,
          }}
          size="compact"
        />
      </Box>

      <PrimaryButton mt={3} mb={5} onClick={handleClose} width="100%">
        Seat Select
      </PrimaryButton>
    </Flex>
  );
};
